
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
// Entities
import { Warehouse, BlockingsFields } from "@/entities/index";

@Component
export default class FilterBar extends Vue {
  @Prop() warehouses: Array<Warehouse> = [];
  @Emit("search") search(blockingsFields: BlockingsFields): void {}
  @Emit("downloadCSV") downloadCSV(): void {}

  blockingsFields: BlockingsFields = {
    reference: "",
    lot: "",
    warehouse: "",
    cause: "",
  };

  onSearch(): void {
    this.search(this.blockingsFields);
  }

  clear(): void {
    const btnClear = document.getElementById("btnClear");
    btnClear?.classList.add("clicked");
    setTimeout(() => {
      btnClear?.classList.remove("clicked");
    }, 500);

    this.blockingsFields = {
      reference: "",
      lot: "",
      warehouse: "",
      cause: "",
    };
  }
}
